<div class="container">

  <div class="title">
    {{ this.headerTitle }}
  </div>

  <div class="profile" (click)="this.clickIn()">
    <div class="actions">
  
      <div class="names">
        <span class="user-name">{{name | titlecase}}</span>
      </div>
  
      <div class="buttons">
        <button mat-icon-button class="avatar" (click)="toggleMenu('avatar')">
          <mat-icon class="avatar-icon">{{ name.charAt(0) | uppercase }}</mat-icon>
        </button>
  
        <button mat-icon-button class="notifs" (click)="toggleMenu('notifs')">
          <mat-icon class="notif-icon">notifications</mat-icon>
        </button>
      </div>
    </div>
  
    <div class="menu" #menu *ngIf="this.menuSection !== ''">
      <div class="avatar-section" *ngIf="this.menuSection === 'avatar'">
        <button mat-stroked-button (click)="logout()">Logout</button>
      </div>
  
      <div class="notifs-section" *ngIf="this.menuSection === 'notifs'">
        <!-- TODO: notification component -->
      </div>
    </div>
  </div>
  </div>